import React, { useState } from 'react';
import { Phone, MessageCircle, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/api';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleCall = () => {
    window.location.href = `tel:${companyInfo.phoneClean}`;
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent(companyInfo.whatsappMessage);
    window.open(`https://wa.me/${companyInfo.phoneClean.replace('+', '')}?text=${message}`, '_blank');
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-zinc-900/95 backdrop-blur-md border-b border-amber-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center shadow-lg shadow-amber-500/30">
              <span className="text-zinc-900 font-black text-lg md:text-xl">T</span>
            </div>
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-white tracking-tight">{companyInfo.name}</h1>
              <p className="text-xs text-amber-400/80 hidden sm:block">Denizli Taksi Hizmeti</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {[
              { label: 'Ana Sayfa', id: 'hero' },
              { label: 'Hizmetler', id: 'services' },
              { label: 'Fiyatlar', id: 'prices' },
              { label: 'Hakkımızda', id: 'about' },
              { label: 'İletişim', id: 'contact' }
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-zinc-300 hover:text-amber-400 transition-colors duration-300 text-sm font-medium"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <Button
              onClick={handleWhatsApp}
              className="bg-green-600 hover:bg-green-700 text-white gap-2 shadow-lg shadow-green-600/30 transition-all duration-300 hover:scale-105"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </Button>
            <Button
              onClick={handleCall}
              className="bg-amber-500 hover:bg-amber-600 text-zinc-900 font-semibold gap-2 shadow-lg shadow-amber-500/30 transition-all duration-300 hover:scale-105"
            >
              <Phone className="w-4 h-4" />
              Hemen Ara
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-white hover:text-amber-400 transition-colors"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-zinc-800 animate-in slide-in-from-top duration-300">
            <nav className="flex flex-col gap-3">
              {[
                { label: 'Ana Sayfa', id: 'hero' },
                { label: 'Hizmetler', id: 'services' },
                { label: 'Fiyatlar', id: 'prices' },
                { label: 'Hakkımızda', id: 'about' },
                { label: 'İletişim', id: 'contact' }
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-zinc-300 hover:text-amber-400 transition-colors py-2 text-left"
                >
                  {item.label}
                </button>
              ))}
            </nav>
            <div className="flex gap-3 mt-4">
              <Button
                onClick={handleWhatsApp}
                className="flex-1 bg-green-600 hover:bg-green-700 text-white gap-2"
              >
                <MessageCircle className="w-4 h-4" />
                WhatsApp
              </Button>
              <Button
                onClick={handleCall}
                className="flex-1 bg-amber-500 hover:bg-amber-600 text-zinc-900 font-semibold gap-2"
              >
                <Phone className="w-4 h-4" />
                Ara
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
